import { BroadcastService } from './broadcast/BroadcastService';
import { BroadcastStateService } from './broadcaststate/BroadcastStateService';
import { EnvironmentService } from './environment/EnvironmentService';
import { MediaService } from './media/MediaService';
import { MetricsService } from './metrics/MetricsService';
import { PluginApiService } from './pluginapi/PluginApiService';
import { PurchaseService } from './purchase/PurchaseService';
import { RecordingService } from './recording/RecordingService';
import { ScheduleService } from './schedule/ScheduleService';
import { TimeService } from './time/TimeService';
import { VideoPropertiesService } from './videoProperties/VideoPropertiesService';
import { ViewerService } from './viewer/ViewerService';
import { ViewerCountService } from './viewercount/ViewerCountService';
// Initialize all the services in the right order.
// The order is important because some services depend on others.
export const initServices = async () => {
    await TimeService.getInstance().init(); // No dependencies
    await EnvironmentService.getInstance().init(); // No dependencies
    await MetricsService.getInstance().init(); // No dependencies
    await MediaService.getInstance().init(); // No dependencies
    await ViewerCountService.getInstance().init(); // No dependencies
    await ScheduleService.getInstance().init(); // Depends on TimeService
    await ViewerService.getInstance().init(); // No dependencies
    await BroadcastService.getInstance().init(); // Depends on MediaService
    await BroadcastStateService.getInstance().init(); // No dependencies
    await PurchaseService.getInstance().init(); // Depends on BroadcastStateService
    await PluginApiService.getInstance().init(); // No dependencies
    await RecordingService.getInstance().init(); // Depends on BroadcastService
    await VideoPropertiesService.getInstance().init(); // No dependencies
};
